exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-about__video-item .thumb{background:url(/assets/img/about/1.png) no-repeat 50%!important;background-size:cover!important}.p-automatize .p-about__video-item .thumb{background:url(/assets/img/about/bg-2.png) no-repeat 50%!important;background-size:cover!important}", ""]);

// exports
